<template>
  <MonitorWrapper>
    <div class="gd-606-container">
      <template v-if="empty">
        <div class="hint">
          {{ isHisDetail ? translateTo('暂无数据') : translateTo('loading') + '...' }}
        </div>
      </template>
      <template v-else>
        <status-bar v-bind="status"></status-bar>
        <chart-wrap ref="chartWrap" :datas="charts"></chart-wrap>
      </template>
    </div>
  </MonitorWrapper>
</template>

<script>
import StatusBar from './components/status-bar.vue';
import ChartWrap from './components/wrap.vue';
import { isObject } from '@/utils/is';
import monitorMixin from '@/mixins/monitorMixin';
import { arrify } from '@/utils/utils';

export default {
  name: 'GM602',
  mixins: [monitorMixin],
  components: {
    StatusBar,
    ChartWrap
  },
  provide() {
    return {
      time: this.time
    };
  },
  data() {
    return {
      status: {
        alarmStatus: 0,
        runState: 0,
        pumpStatus: {
          install: 0,
          run: 0
        },
        humidity: 0,
        temperature: 0
      },
      charts: [],
      time: {},
      empty: false,
      modName: 'gm602Mod'
    };
  },
  methods: {
    getGM602Mod(res) {
      if (!res || !res.mods || !res.mods[this.modName]) return null;
      return res.mods[this.modName];
    },
    setData(res) {
      try {
        const { status, charts } = this;
        const { runstate, state, mods, beginTime } = res;
        const { gm602Mod } = mods;
        if (!gm602Mod || !gm602Mod.sensors) return;
        this.time.begin = beginTime;
        Object.assign(status, {
          runState: runstate,
          alarmStatus: state
        });
        // Object.assign(pumpStatus, {
        //   run: gm602Mod.pumpRunstate,
        //   install: gm602Mod.pumpInstallState
        // });
        charts.splice(0, Infinity, ...gm602Mod.sensors);
        this.empty = false;
      } catch (err) {
        console.error('[GM602][MONITRO][update error]', err);
      }
    },
    updateData(res) {
      if (!this.isHisDetail) this.setData(res);
    },
    updateHisData(res) {
      if (!isObject(res) || !isObject(res.data)) return;
      const { deviceData, deviceDatas } = res.data;
      if (!Array.isArray(deviceDatas)) return;
      this.setData(deviceData);
      let mod = null;
      const list = deviceDatas
        .map(e => {
          mod = this.getGM602Mod(e);
          if (!mod) return;
          return { sensors: arrify(mod.sensors), beginTime: e.beginTime };
        })
        .filter(e => isObject(e));
      this.$refs.chartWrap.setData(list, this.getGM602Mod(deviceData));
    }
  }
};
</script>

<style lang="scss">
.gd-606-container {
  width: 100%;
  height: 100%;
  span {
    @include state-textstyle;
  }
  .hint {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .common-border2 {
    border: 1px solid rgb(96, 118, 173);
  }
  .common-border {
    height: 100%;
    padding: 2px;
    background-image: url('~@/assets/image/lt.png'), url('~@/assets/image/rt.png'),
      url('~@/assets/image/lb.png'), url('~@/assets/image/rb.png'),
      url('~@/assets/image/linelight.png');
    background-repeat: no-repeat, no-repeat, no-repeat, no-repeat, no-repeat;
    background-position: top left, top right, bottom left, bottom right, center -5px;
    .comp3-content {
      height: 100%;
      box-sizing: border-box;
    }
  }
}
</style>
